<div class="program_access_table">
    <div class="roww head_row">
        <span class="name">Program Name</span>
        <span class="role" *ngFor="let role of orgRoles">{{role.name}}</span>
    </div>

    <div class="content_box" *ngFor="let category of categories">
        <ng-container *ngIf="categoryHasPrograms(category)">
            <span class="categ_head"> <img class="folder_icon" src="../../../../../../../assets/images/folder_icon.png" alt=""> {{category.name}}</span>
            <div class="sub_div" *ngFor="let subCategory of category.subCategories; let i = index">
                <ng-container *ngIf="subCategoryHasPrograms(subCategory)">
                    <div class="ques">
                       <span class="arrow">
                        <img class="dropDown" (click)="showProgramsData('show', i, category)" *ngIf="!subCategory.showPrograms"  src="../../../../../../../assets/images/dropdown_arrow.png" alt="">
                        <img class="dropDown" (click)="showProgramsData('hide', i, category)" class="rotate"  *ngIf="subCategory.showPrograms" src="../../../../../../../assets/images/dropdown_arrow.png" alt="">
                       </span>  {{subCategory.name}}
                    </div>

                    <ng-container *ngIf="subCategory.showPrograms">
                        <div class="roww programs" *ngFor="let program of subCategory.programs">
                            <span class="column-6">{{program.name}}</span>
                            <span class="column-1" *ngFor="let role of orgRoles">
                                <mat-slide-toggle [checked]="getToggleState(program, role)"
                                    (change)="toggleRoleForProgram(program, role, $event.checked)"></mat-slide-toggle>
                            </span>
                        </div>
                    </ng-container>
                    

                   
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>

<button (click)="saveOrganisationData()" class="saveBtn">Save</button>